import React from "react";
import Products from "./Products";
import "./Home.css";
import banner from "../assets/images/banner.jpg";

function Home() {
  return (
    <div className="hero">
      <div className="card bg-dark text-white border-0 hero-card">
        <img src={banner} className="card-img hero-img" alt="Background" height="600px" />
        <div className="card-img-overlay d-flex flex-column justify-content-center align-items-start">
          <div className="container text-start">
            <h5 className="display-3 fw-bolder mb-2 animate-title">
              NEW SEASON ARRIVALS
            </h5>
            <p className="lead fs-2 animate-subtitle">CHECK OUT ALL THE TRENDS</p>
            <button className="btn btn-warning btn-lg px-4 mt-3 fw-bold shadow explore-btn">
              Shop Now <i className="fa fa-arrow-right ms-2"></i>
            </button>
          </div>
        </div>
      </div>
      <Products />
    </div>
  );
}

export default Home;
